import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

/** Scroll window to top on client-side navigation (fixes landing at bottom of next page). */
export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
}
